import debounce from 'debounce';
export default class {
  constructor() {

    this.button = document.getElementById('scroll-to-top');

    if (!this.button) {
      return;
    }

    this.visibilityOffset = document.body.clientHeight/6;
    this.horizontalOffset = 32;
    this.width = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) / 2;

    this.handler();
    this.visibility();

    this.horizontalPosition();
  }

  horizontalPosition() {
    if(window.matchMedia('(min-width: 1280px)').matches) {
      this.horizontalOffset = (this.width - 640) + 10;
    }

    this.button.style.right = this.horizontalOffset + 'px';
  }

  visibility() {
    let self = this;
    window.addEventListener('scroll', debounce(function() {
      if (document.body.scrollTop > self.visibilityOffset || document.documentElement.scrollTop > self.visibilityOffset) {
        document.body.classList.add('scroll-to-top-active');
      } else {
        document.body.classList.remove('scroll-to-top-active');
      }
    }), 100);
  }


  handler() {
    this.button.onclick = function () {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };
  }
}
